












// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { AssetVersion } from "@/psychlab/types/assets";
import { useAssets } from "@/hooks/useAssets";
// local
import { useVersionCache } from "../../ts/useVersionCache";

export default defineComponent({

	emits:[],
	props:{
		asset:{
			type:String,
			required:true,
		},
		version:{
			type:String,
			required:true,
		},
		variant:{
			type:String,
			default:"info"
		}
	},
	components:{
	},
	setup(props){


		const {
			assets
		} = useAssets();

		const {
			getVersionList
		} = useVersionCache();

		const versions = ref<AssetVersion<any>[]>([]);

		const asset = computed(() => {
			return assets.value.find(a => a._id === props.asset);
		});

		const assetName = computed(() =>{
			return asset.value ? asset.value.name : "";
		});

		const versionLabel = computed(() =>{
			const vr = versions.value.find(v => v._id === props.version);
			return `${vr ? (vr.vIndex + 1).toString() : ""}`

		});

		const init = async () => {
			try {
				versions.value = await getVersionList(props.asset);
			}catch{}
		};

		init();

		return {
			assetName,
			versionLabel,
		};
	}
});

